import * as React from 'react'
import type { AnchorHTMLAttributes } from 'react'

interface DropdownTriggerProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode
  className?: string
  type?: string
}

const DropdownTrigger = React.forwardRef<
  HTMLAnchorElement,
  DropdownTriggerProps
>(({ children, className = '', ...dropdownTriggerProps }, ref) => {
  return (
    <a
      ref={ref}
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={0}
      className={`dropdown__trigger ${className}`}
      {...dropdownTriggerProps}
    >
      {children}
    </a>
  )
})

DropdownTrigger.displayName = 'DropdownTrigger'

export default DropdownTrigger
